<button
    class="w-full h-full rounded-[14px] border-spacing-2 border-2 border-primary-500 border-dashed bg-primary-200 flex flex-col justify-evenly items-center select-none p-2"
    (click)="fileInput.click()" (dragover)="fileUploadHelper.onDragOver($event)"
    (drop)="fileUploadHelper.onDrop($event)">
    <input #fileInput type="file" accept=".pdf,.xls,.xlsx" (change)="fileUploadHelper.onFileSelected($event)"
        class="hidden" multiple>

    <img src="assets/icons/upload-circle.svg" width="60px" height="60px" alt="{{ 'shared.upload_icon' | transloco }}">
    <p class="text-center text-sm text-neutral-1200"><span class="underline">{{
            'shared.click_to_upload.click' | transloco}}</span>{{ 'shared.click_to_upload.to_upload' |
        transloco}}<span class="underline">{{ 'shared.click_to_upload.drag_and_drop' |
            transloco}}</span>{{ 'shared.click_to_upload.contract_files' | transloco}}</p>
</button>